import { computed, configure, decorate } from 'mobx';
import { RootStore } from './RootStore';

configure({ enforceActions: 'observed' });

type menuNavRawType = {
  readonly asset_assetid: string;
  readonly 'asset_name^rawurlencode': string;
  readonly 'asset_short_name^rawurlencode': string;
  readonly asset_url_path: string;
  readonly link_url: string;
};

type menuNavType = {
  readonly assetId: string;
  readonly linkUrl: string | null;
  readonly name: string;
  readonly shortName: string;
  readonly urlPath: string;
};

type siteFooterType<T> = {
  links?: T[];
  readonly logo: string;
  readonly text: string;
  readonly legal: string;
};

type footerRawLinks = {
  readonly 'asset_name^rawurlencode': string;
  readonly asset_url: string;
};

type footerLinks = {
  readonly linkName: string;
  readonly linkUrl: string;
};

const ifStateSite: boolean = window.sq && window.sq.state && window.sq.state.site;

export class SiteStore {
  rootStore: RootStore;
  siteName: string;
  siteLogo: string;
  siteURL: string;
  searchAPI: string;
  siteMenu: menuNavRawType[] | null;
  siteFooter: siteFooterType<footerRawLinks> | null;
  pageNotFound: string | null;
  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    this.siteName =
      ifStateSite && window.sq.state.site.siteName ? window.sq.state.site.siteName : '';
    this.siteLogo =
      ifStateSite && window.sq.state.site.siteLogo ? window.sq.state.site.siteLogo : '';
    this.siteURL = ifStateSite && window.sq.state.site.siteURL ? window.sq.state.site.siteURL : '';
    this.searchAPI =
      ifStateSite && window.sq.state.site.searchAPI ? window.sq.state.site.searchAPI : '';
    this.siteMenu =
      ifStateSite && window.sq.state.site.siteMenu ? window.sq.state.site.siteMenu : null;
    this.siteFooter =
      ifStateSite && window.sq.state.site.siteFooter ? window.sq.state.site.siteFooter : null;
    this.pageNotFound =
      ifStateSite && window.sq.state.site.pageNotFound ? window.sq.state.site.pageNotFound : null;
  }

  get getMenuNav(): menuNavType[] | null {
    return this.siteMenu
      ? this.siteMenu.reduce(
          (menuNav, menu) => {
            return menuNav.concat({
              assetId: menu.asset_assetid,
              linkUrl: menu.link_url.length > 0 ? menu.link_url : null,
              name: menu['asset_name^rawurlencode'],
              shortName: menu['asset_short_name^rawurlencode'],
              urlPath: menu.asset_url_path,
            });
          },
          [] as menuNavType[]
        )
      : null;
  }

  get getFooterLinks(): footerLinks[] | null {
    if (this.siteFooter && this.siteFooter.links) {
      return this.siteFooter.links.reduce(
        (convertLink, link) => {
          return convertLink.concat({
            linkName: link['asset_name^rawurlencode'],
            linkUrl: link.asset_url,
          });
        },
        [] as footerLinks[]
      );
    }
    return null;
  }
  get getFooterContent(): siteFooterType<footerLinks> | null {
    return this.siteFooter
      ? { logo: this.siteFooter.logo, text: this.siteFooter.text, legal: this.siteFooter.legal }
      : null;
  }

  get getPageNotFound(): string | null {
    return this.pageNotFound;
  }
}

decorate(SiteStore, {
  getFooterContent: computed,
  getFooterLinks: computed,
  getMenuNav: computed,
  getPageNotFound: computed,
});
